import React, { useState } from "react";
import { Table, Space, Button } from "antd";
import c from "../utils/common";
import metaData from "../data/metaData";
import log from "../utils/log";
import Meta from "./Meta";
import ActionHeader from "./Table/ActionHeader";
import CheckBox from "./General/Checkbox";
import ShopLogo from "./Shop/Logo";

const ShopTable = ({
  data,
  loading,
  canAdd = false,
  canDelete = false,
  canSelect,
  onSelect,
  onAdd,
  onDelete,
  companyId,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [pagination, setPagination] = useState(1);
  const [filteredDataCount, setFilteredDataCount] = useState(data.length);

  const columns = [
    {
      title: "Shop ID",
      dataIndex: "id",
      key: "id",
      width: 150,
    },
    {
      title: "Brand / Company",
      dataIndex: "brand.name",
      key: "brand.name",
      render: (text, record) => {
        let { company, brand } = record || {};

        return (
          <Meta
            image={
              <ShopLogo
                style={{ width: 40, height: 40, objectFit: "cover", marginRight: "0.5rem" }}
                logo={record?.logo}
                brandLogo={brand?.logo}
              />
            }
            title={brand?.name}
            description={company?.name}
          />
        );
      },
      sorter: (a, b) => (a?.brand?.name).localeCompare(b?.brand?.name),
    },
    {
      title: "Shop",
      dataIndex: "name",
      key: "name",
      width: 300,
      render: (text, record) => {
        return <Meta title={record?.name} description={c.getDisplayAddress(record?.address)} maxWidth={200} />;
      },
      sorter: (a, b) => (a?.name).localeCompare(b?.name),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => {
        let { company, brand } = record || {};

        return (
          <Space size="middle">
            {canDelete && company?.id !== companyId ? (
              <Button danger loading={loading} onClick={() => onDelete(record?.id)}>
                Remove
              </Button>
            ) : null}
            {canAdd ? (
              <Button type="primary" loading={loading} onClick={() => onAdd(record?.id)}>
                Add
              </Button>
            ) : null}
            {canSelect ? (
              <CheckBox
                checked={record?.selected}
                size="1.75rem"
                onClick={(e) => {
                  e.stopPropagation(); // Prevent the row click event from being triggered
                  onSelect(record?.id);
                }}
              />
            ) : null}
          </Space>
        );
      },
    },
  ];

  const handleActionClick = (key) => {
    log.debug(key);
  };

  // Handle pagination change (page number or page size change)
  const handleTableChange = (pagination, filters, sorter, extra) => {
    const { current, pageSize } = pagination;
    setPagination(current);
    setFilteredDataCount(extra.currentDataSource.length);
  };

  return (
    <>
      <ActionHeader
        pagination={pagination}
        pageSize={5}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        count={filteredDataCount}
        onActionClick={handleActionClick}
      />

      <Table
        className="white-table-header"
        columns={columns}
        dataSource={data}
        pagination={{
          current: pagination,
          pageSize: 5,
          position: ["none", "bottomCenter"],
          showSizeChanger: false,
        }}
        onRow={
          canSelect
            ? (record) => ({
                onClick: () => {
                  onSelect(record.id);
                },
              })
            : undefined
        }
        onChange={handleTableChange} // Handles next/prev page
      />
    </>
  );
};

export default ShopTable;
